import { GetCacheOpts } from '@common-modules/cache/http-cache/http-cache.client';

export class ApiRequestBuilderSettings {
  endpoint: string;
  queryParams?: { [key: string]: any };
  pathParams?: { [key: string]: any };
  method: 'get' | 'post' | 'put' | 'delete' = 'get';
  body?: any;
  cacheOpts?: GetCacheOpts;
  absoluteUrl?: boolean;

  constructor(data: Partial<ApiRequestBuilderSettings>) {
    Object.assign(this, data);
  }
}
